const doc = [({"ko":({"adminButtonHotelCancelPolicy":({"cancelPolicySetting":"취소 정책 설정", "deleteCancelPolicy":"정책을 삭제하려면", "deleteCancelPolicySetting":"취소 정책 설정 삭제"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;